export var AnimationTypesConstants;
(function (AnimationTypesConstants) {
    AnimationTypesConstants["WalkingCitizens"] = "WalkingCitizens";
})(AnimationTypesConstants || (AnimationTypesConstants = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/animationTypesConstants.ts
// module id = 867
// module chunks = 3